import React, { useState } from "react";
import "./Profile.css";
import Left_Sidebar from "./left_sidebar/Left_Sidebar";
import User_Profile from "./user_profile/User_Profile";
import Right_Side_Content from "./right_side_content/Right_Side_Content";
import { Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightLeft } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import Ordered from "./right_side_content/orders_tabs/ordered/Ordered";
import Delivered from "./right_side_content/orders_tabs/delivered/Delivered";
import Cancelled from "./right_side_content/orders_tabs/cancelled/Cancelled";
import Log_out_modal from "../common/modals/common-modal/log-out-modal/Log_out_modal";
import Returned from "./right_side_content/orders_tabs/returned/Returned";
import Bookings from "./right_side_content/orders_tabs/bookings/Bookings";

const Profile = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [logoutModal, setLogoutModal] = useState(false);

  const [activeInnerTab, setActiveInnerTab] = useState(null);
  const navigate = useNavigate();

  const handleNavClick = (mainLabel, innerLabel) => {
    if (mainLabel === "Orders") {
      setActiveInnerTab(innerLabel || "Ordered");
    } else if (mainLabel === "Bookings") {
      setActiveInnerTab(innerLabel || "Bookings");
    } else {
      switch (mainLabel) {
        case "Wishlist":
          navigate("/wishlist");
          break;
        case "Wallet":
          navigate("/add-wallet");
          break;
        case "Notifications":
          navigate("/notification");
          break;
        case "Have a Question?":
          navigate("/have-a-question");
          break;
        case "Log Out":
          navigate("/logout");
          break;
        default:
          break;
      }
    }
  };

  return (
    <section className="Profile">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-3 col-0 mb-lg-0  mb-4">
            <div className="desktop_left_sidebar_holder">
              <Left_Sidebar onNavClick={handleNavClick} setLogoutModal={setLogoutModal} />
            </div>

            <div className="mobileviewsidebar">
              <button className="sidebaropnbtn" onClick={handleShow}>
                <FontAwesomeIcon icon={faRightLeft} />
              </button>
              <Offcanvas
                className="mobile_offcanvas"
                show={show}
                onHide={handleClose}
                scroll={false}
                backdrop={true}
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title>
                    <img
                      src="/assets/images/logo/logo.png"
                      className="logo_img"
                    />
                  </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <Left_Sidebar
                    setLogoutModal={setLogoutModal}
                    onNavClick={handleNavClick}
                    onClose={handleClose}
                  />
                </Offcanvas.Body>
              </Offcanvas>
            </div>
          </div>

          {activeInnerTab === null ? (
            <>
              <div className="col-lg-5 col-md-7 col-sm-10">
                <div className="middle_div">
                  <User_Profile />
                </div>
              </div>

              <div className="col-lg-4 col-md-5 col-sm-10">
                <div className="left_sidebar_holder">
                  <Right_Side_Content />
                </div>
              </div>
            </>
          ) : activeInnerTab === "All Bookings" ? (
            <div className="col-lg-9 col-md-9 col-sm-10">
              <Bookings />
            </div>
          ) : activeInnerTab === "Ordered" ? (
            <div className="col-lg-9 col-md-9 col-sm-10">
              <Ordered />
            </div>
          ) : activeInnerTab === "Delivered" ? (
            <div className="col-lg-9 col-md-9 col-sm-10">
              <Delivered />
            </div>
          ) : activeInnerTab === "Cancelled" ? (
            <div className="col-lg-9 col-md-9 col-sm-10">
              <Cancelled />
            </div>
          ) : activeInnerTab === "Returned" ? (
            <div className="col-lg-9 col-md-9 col-sm-10">
              <Returned />
            </div>
          ) : null}
        </div>
      </div>

      <Log_out_modal
        show={logoutModal}
        onHide={() => setLogoutModal(false)}
        headtext={"Log Out"}
        successfultext={"Are you sure, you want to logout?"}
      />
    </section>
  );
};

export default Profile;
